//= ====== Funkcija za formatiranje datuma iz baze =======
export const formatDateFromDB = (todayISO) => {
  if (todayISO !== null) {
    const DateISO = new Date(todayISO);
    const dd = DateISO.getDate(); // 10
    const mm = DateISO.getMonth() + 1;
    const yyyy = DateISO.getFullYear();
    const todayMmmin = `${dd < 10 ? '0' : ''}${dd}.${
      mm < 10 ? '0' : ''
    }${mm}.${yyyy}.`;
    return todayMmmin;
  }
  return null;
};

export const formatDateFromDB2 = (todayISO) => {
  if (todayISO !== null) {
    const DateISO = new Date(todayISO);
    const dd = DateISO.getDate(); // 10
    const mm = DateISO.getMonth() + 1;
    const yyyy = DateISO.getFullYear();
    const todayMmmin = `${yyyy}-${mm < 10 ? '0' : ''}${mm}-${
      dd < 10 ? '0' : ''
    }${dd}`;
    return todayMmmin;
  }
  return null;
};
//= ====== Funkcija za formatiranje datuma iz baze =======
export const formatDateTime = (todayISO) => {
  if (todayISO !== null) {
    const DateISO = new Date(todayISO);
    const dd = DateISO.getDate(); // 10
    const MM = DateISO.getMonth() + 1;
    const yyyy = DateISO.getFullYear();
    const HH = DateISO.getHours();
    const mm = DateISO.getMinutes();
    const todayMmmin = `${HH < 10 ? '0' : ''}${HH}:${mm < 10 ? '0' : ''}${mm} ${
      dd < 10 ? '0' : ''
    }${dd}.${MM < 10 ? '0' : ''}${MM}.${yyyy}.`;
    return todayMmmin;
  }
  return null;
};
//= ================Funkija za formatiranje timestampa =========================
export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const yyyy = date.getFullYear();
  const dd = date.getDate(); // 10
  const MM = date.getMonth() + 1;
  const HH = date.getHours();
  const mm = date.getMinutes();
  const todayMmmin = `${HH < 10 ? '0' : ''}${HH}:${mm < 10 ? '0' : ''}${mm} ${
    dd < 10 ? '0' : ''
  }${dd}.${MM < 10 ? '0' : ''}${MM}.${yyyy}.`;
  return todayMmmin;
};
//= ======================================================
export const formatDateGrid = (todayISO) => {
  const DateISO = new Date(todayISO);
  const dd = DateISO.getDate(); // 10
  const MM = DateISO.getMonth() + 1;
  const yyyy = DateISO.getFullYear();
  const HH = DateISO.getHours();
  const mm = DateISO.getMinutes();
  const todayMmmin = `${yyyy}-${MM}-${dd} ${HH}:${mm}`;
  return todayMmmin;
};
//= ====== Funkcija za slanje datuma u bazu ========
export const formatDateToDB = (dateISO) => {
  if (dateISO !== null) {
    const date = new Date(dateISO);
    const day = date.getDate(); // 10
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const sendDate = `${year}-${month}-${day}`;
    return sendDate;
  }
  return null;
}; //= ================================================
//= ====== Funkcija za slanje datuma u bazu ( FROM BODY )========
export const formatDateBody = (dateISO) => {
  if (dateISO !== null) {
    const date = new Date(dateISO);
    const day = date.getDate(); // 10
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const sendDate = `${year}-${month < 10 ? '0' : ''}${month}-${
      day < 10 ? '0' : ''
    }${day}`;
    return sendDate;
  }
  return null;
}; //= ================================================

//  ======== f-ja za prikaz sutrasnjeg datuma =========
export const addOneDay = (date) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 1);

  // provera da li sledeci dan prelazi u sledeci mesec
  if (newDate.getMonth() !== date.getMonth()) {
    newDate.setMonth(date.getMonth() + 1);
    newDate.setDate(1); // ako prelazi, setovati datum na 1.
  }

  return newDate;
};

// f-ja za dodavanje n godina na kraju datuma
export const addYears = (date, years) => {
  const newDate = new Date(date);
  newDate.setFullYear(newDate.getFullYear() + years);
  return newDate;
};

// formatiranje date time picker-a
export const formatDateForInputType = (date) => {
  const pad = (num) => (num < 10 ? `0${num}` : num);
  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

// formatiranje date time za grid
export const formatDateTimeGrid = (todayISO) => {
  const DateISO = new Date(todayISO);
  const dd = String(DateISO.getDate()).padStart(2, '0'); // Pad with leading zero if needed
  const MM = String(DateISO.getMonth() + 1).padStart(2, '0'); // Month is zero-based
  const yyyy = DateISO.getFullYear();
  const HH = String(DateISO.getHours()).padStart(2, '0');
  const mm = String(DateISO.getMinutes()).padStart(2, '0');

  const formattedDate = `${dd}.${MM}.${yyyy} ${HH}:${mm}`;
  return formattedDate;
};
